import React from 'react';
import PropTypes from 'prop-types';
import Box from 'common/src/components/Box';
import Text from 'common/src/components/Text';
import Fade from 'react-reveal/Fade';
import Heading from 'common/src/components/Heading';
import Button from 'common/src/components/Button';
import Input from 'common/src/components/Input';
import Container from 'common/src/components/UI/Container';

import ContactFromWrapper from './contact.style';

const ContactSection = ({
  bg,
  color,
  sectionWrapper,
  row,
  contactForm,
  secTitleWrapper,
  secHeading,
  secText,
  button,
  note
}) => {
  return (
    <Container>
      <Fade bottom delay={30}>
        <ContactFromWrapper>
          <Box
            {...sectionWrapper}
            className="box-container"
            style={{
              background: bg ? bg : '#ECEAEA'
            }}
          >
            <Container>
              <Box {...secTitleWrapper} style={{ marginBottom: '30px' }}>
                <Heading
                  className="text-content"
                  style={{
                    color: color ? color : '#000000'
                  }}
                  {...secHeading}
                  content="Get started for FREE in 5 minutes or less"
                />
              </Box>
              <Box {...row}>
                <Box {...contactForm} style={{ textAlign: 'center' }}>
                  <Button
                    {...button}
                    className="btn-acc"
                    title="Sign Up"
                    onClick={() => {
                      {
                        window.location.href = `${process.env.FLIPSERVE_CLIENT_URL}auth/register/customer`;
                      }
                    }}
                  />
                </Box>
              </Box>
            </Container>
          </Box>
        </ContactFromWrapper>
      </Fade>
    </Container>
  );
};

ContactSection.propTypes = {
  sectionWrapper: PropTypes.object,
  secTitleWrapper: PropTypes.object,
  row: PropTypes.object,
  contactForm: PropTypes.object,
  secHeading: PropTypes.object,
  secText: PropTypes.object,
  button: PropTypes.object,
  note: PropTypes.object
};

ContactSection.defaultProps = {
  sectionWrapper: {
    id: 'contact_section',
    as: 'section',
    pt: ['0px', '10px', '20px', '80px'],
    pb: ['0px', '0px', '0px', '0px', '80px'],
    bg: '#f9fbfd'
  },
  secTitleWrapper: {
    mb: ['45px', '50px', '60px']
  },
  secText: {
    as: 'span',
    display: 'block',
    textAlign: 'center',
    fontSize: `${2}`,
    letterSpacing: '0.15em',
    fontWeight: `${6}`,
    color: 'primary',
    mb: `${3}`
  },
  secHeading: {
    textAlign: 'center',
    fontSize: [`${6}`, `${8}`],
    fontWeight: '400',
    color: 'headingColor',
    letterSpacing: '-0.025em',
    mb: `${0}`
  },
  row: {
    flexBox: true,
    justifyContent: 'center'
  },
  contactForm: {
    width: [1, 1, 1, 1 / 2]
  },
  button: {
    type: 'button',
    fontSize: `${2}`,
    fontWeight: '600',
    borderRadius: '4px',
    pl: '22px',
    pr: '22px',
    colors: 'primaryWithBg',
    height: `${4}`
  },
  note: {
    fontSize: ['13px', '14px', '15px', '15px', '15px'],
    color: '#5d646d',
    lineHeight: '1.87',
    textAlign: 'center'
  }
};

export default ContactSection;
